import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from "@mui/material";
import {
  SaveTestQualityControlType,
  UpdateTestQualityControlType,
} from "../../../../services/TestLibService";
import { NotificationManager } from "react-notifications";

const AddTestQualityControlTypeDialog = ({
  open,
  onClose,
  onSave,
  selectedQcType,
}) => {
  const [qcType, setQcType] = useState("");
  const [description, setDescription] = useState("");
  const [formulaId, setFormulaId] = useState("");
  const [units, setUnits] = useState("");
  const [caption, setCaption] = useState("");
  const [minLimit, setMinLimit] = useState("");
  const [maxLimit, setMaxLimit] = useState("");
  const [lwl, setLwl] = useState("");
  const [uwl, setUwl] = useState("");

  useEffect(() => {
    if (selectedQcType) {
      setQcType(selectedQcType.qcType || "");
      setDescription(selectedQcType.description || "");
      setFormulaId(selectedQcType.formulaId || "");
      setUnits(selectedQcType.units || "");
      setCaption(selectedQcType.caption || "");
      setMinLimit(selectedQcType.minLimit || "");
      setMaxLimit(selectedQcType.maxLimit || "");
      setLwl(selectedQcType.lwl || "");
      setUwl(selectedQcType.uwl || "");
    } else {
      setQcType("");
      setDescription("");
      setFormulaId("");
      setUnits("");
      setCaption("");
      setMinLimit("");
      setMaxLimit("");
      setLwl("");
      setUwl("");
    }
  }, [selectedQcType]);

  const handleSave = async () => {
    try {
      const qcTypeData = {
        qcType,
        description,
        formulaId,
        units,
        caption,
        minLimit: parseFloat(minLimit) || null,
        maxLimit: parseFloat(maxLimit) || null,
        lwl: parseFloat(lwl) || null,
        uwl: parseFloat(uwl) || null,
      };

      let response;
      if (selectedQcType) {
        response = await UpdateTestQualityControlType(qcTypeData);
        NotificationManager.success(
          "Test quality control type updated successfully"
        );
      } else {
        response = await SaveTestQualityControlType(qcTypeData);
        NotificationManager.success(
          "Test quality control type saved successfully"
        );
      }

      if (response.status === 200) {
        onSave();
        onClose();
      } else {
        NotificationManager.error(
          "Error saving/updating test quality control type"
        );
      }
    } catch (error) {
      NotificationManager.error(
        "Error saving/updating test quality control type"
      );
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {selectedQcType
          ? "Edit Test Quality Control Type"
          : "Add New Test Quality Control Type"}
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              label="QC Type"
              value={qcType}
              onChange={(e) => setQcType(e.target.value)}
              fullWidth
              size="small"
              variant="outlined"
              required
              InputProps={{
                readOnly: selectedQcType,
                inputProps: {
                  maxLength: 6,
                },
              }}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              label="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              fullWidth
              size="small"
              variant="outlined"
              inputProps={{ maxLength: 100 }}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              label="Formula ID"
              value={formulaId}
              onChange={(e) => setFormulaId(e.target.value)}
              fullWidth
              size="small"
              variant="outlined"
              inputProps={{ maxLength: 50 }}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              label="Units"
              value={units}
              onChange={(e) => setUnits(e.target.value)}
              fullWidth
              size="small"
              variant="outlined"
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              label="Caption"
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
              fullWidth
              size="small"
              variant="outlined"
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              label="Min Limit"
              value={minLimit}
              onChange={(e) => setMinLimit(e.target.value)}
              fullWidth
              size="small"
              variant="outlined"
              type="number"
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              label="Max Limit"
              value={maxLimit}
              onChange={(e) => setMaxLimit(e.target.value)}
              fullWidth
              size="small"
              variant="outlined"
              type="number"
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              label="Lower Warning Limit (LWL)"
              value={lwl}
              onChange={(e) => setLwl(e.target.value)}
              fullWidth
              size="small"
              variant="outlined"
              type="number"
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              label="Upper Warning Limit (UWL)"
              value={uwl}
              onChange={(e) => setUwl(e.target.value)}
              fullWidth
              size="small"
              variant="outlined"
              type="number"
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          {selectedQcType ? "Update" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTestQualityControlTypeDialog;
